<template>
  <div class="manage" style="width: 100%; height: 100%;">
    <div class="top">
      <el-button type="primary" style="height: 40px;" @click="handleUpdate">升级BOOT固件</el-button>
    </div>

    <el-table :data="tableData.firmwares" :stripe="true">
      <el-table-column label="序号" prop="id" align="center" width="50" />
      <el-table-column label="BOOT固件号" prop="version" align="center" width="120" />
      <el-table-column label="日期" prop="date" align="center" width="120" />
      <el-table-column label="地址" prop="url" align="center" width="300" />
      <el-table-column label="配置字段" prop="pre_config" align="center" width="300" />
      <el-table-column label="说明" prop="description" align="center" width="200" />
      <el-table-column label="Actions" width="180">
        <template slot-scope="scope">
          <el-button @click="deleteRow(scope.$index, scope.row)" type="danger" size="mini">删除</el-button>
          <el-button @click="handleDetail(scope.$index, scope.row)" size="mini">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;">
      <el-pagination layout="sizes, prev, pager, next"
        :total="tableData.total_items"
        :page-size="tableData.size"
        :page-count="tableData.total_pages"
        :page-sizes="[5, 10, 15, 20]"
        :current-page.sync = "tableData.page"
        @current-change = "handlePageChanged"
        @size-change = "handleSizeChange">
      
      </el-pagination>
    </div>
  </div>
</template>

<script>
import http from '@/utils/request';
import { getBootFirmwares } from '@/api';

export default {
  data() {
    return {
      tableData: [],
      pageSize: 5
    };
  },
  mounted() {
    getBootFirmwares(1, this.pageSize).then(resp => {
      console.log('response', resp.ok, resp.status === 200, resp.data.code === 200);
      if (resp.status === 200 && resp.data.code === 200) {
        this.tableData = resp.data.data;
        this.pageSize = this.tableData.size;
        console.log('table data: ', this.tableData);
      }
    }).catch(error => {
      this.$message.error('尚不支持该操作，请等待接口更新!', error);
    });
  },
  methods: {
    deleteRow(index, row) {
      console.warn('deleting row:', row, ', index', index);
      this.$confirm('确定要删除BOOT固件版本号 ' + row.version + ' 吗?',"删除提示",{
        iconClass: 'el-icon-question',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        showClose: true,
        type: 'warning'
      }).then(res => {
        var formData = new FormData();
        formData.append('version', row.version);

        http.post('/firmware/del_boot_firmware', formData).then(res => {
          if (res.data.code === 200) {
            this.$message({showClose: true, message: "删除成功!", type: "success", duration: 1000, center: true})
            // 重新刷新到第一页
            this.handlePageChanged(1);
          }
        });
      }).catch(error => {
        console.log('delete failed!', error);
      })
    },
    handleSizeChange(size) {
      getBootFirmwares(1, size).then(resp => {
        this.tableData = resp.data.data;
        this.pageSize = this.tableData.size;

        console.log('current size:', size, this.pageSize);
        // if (resp.status === 200 && resp.data.code === 200) {
        //   this.tableData = resp.data.data;
        //   this.pageSize = this.tableData.size;

        //   console.log('current size:', size, this.pageSize);
        // }
      }).catch(error => {
        console.log('get firmwares in page No.1 failed when page_size changed!', error);
      })
    },
    handlePageChanged(page) {
      console.log('current page is ', page);
      getBootFirmwares(page, this.pageSize).then( resp => {
        this.tableData = resp.data.data;
        this.pageSize = this.tableData.size;
        console.log('page size', this.pageSize)
        // if (resp.status === 200 && resp.data.code === 200) {
        //   this.tableData = resp.data.data;
        //   this.pageSize = this.tableData.size;
        //   console.log('page size', this.pageSize)
        // }
      }).catch(error => {
        console.error('handle page changed failed!', error);
      })
    },
    handleUpdate() {
      // 通过路由跳转到升级BOOT固件的页面
      this.$router.push('/boot_fw_upgrade')
    },
    handleDetail(index, row) {
      console.warn('details row:', row, ', index', index);
      // 向页面传递参数，区分新增和详情
      this.$router.push({path: '/boot_fw_upgrade', query: { boot_fw: row }});
    }
  }
}
</script>